import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PartsScheduleComponent } from './parts-schedule.component';

const routes: Routes = [
  {
    path: '',
    component: PartsScheduleComponent,
    data: { pageTitle: 'navigation.partsScheduleDashboard' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartsScheduleRoutingModule { }
